import "./InventoryChartKey.css";

import { ColorConstants } from "../../../../../../../constants";

interface InventoryChartKeyProps {
  unitMeasurement: string;
  showAvailable: boolean;
}

export const InventoryChartKey = ({ unitMeasurement, showAvailable }: InventoryChartKeyProps): JSX.Element => {
  return (
    <div className="InventoryChartKey">
      <h3>{unitMeasurement === "Biodiversity" ? "Units" : "Verified"}</h3>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_600 }} />
        <p>Allocated</p>
      </div>
      {showAvailable && (
        <div className="KeyItem">
          <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_200 }} />
          <p>Available</p>
        </div>
      )}
      {unitMeasurement !== "Biodiversity" && (
        <>
          <div className="KeyBreak" />
          <h3>Pending</h3>
          <div className="KeyItem">
            <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_500 }} />
            <p>Allocated</p>
          </div>
          {showAvailable && (
            <div className="KeyItem">
              <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_100 }} />
              <p>Available</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};
